<template>
  <div>
    <component v-for="field of fields" :data="field" :key="field.name" :is="field.field" v-model="data[field.name]" v-bind="field.props" :disabled="disabled"></component>
  </div>
</template>

<script>
/**
 *  fields example: [
 *    {
 *      name: 'ip',
 *      field: 'input-field',
 *      props: {
 *        label: 'ip address',
 *        validate: 'required'
 *      }
 *    }
 *  ]
 */
  import InputField from './input-field'
  import NumberField from './number-field'
  import SelectField from './select-field'
  import PasswordField from './password-field'

  export default {
    data () {
      return {
        watcherList: [],
        data: {}
      }
    },
    props: {
      value: {
        required: true,
        type: Object
      },
      fields: {
        required: true,
        type: Array,
        default: []
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    components: {
      InputField,
      SelectField,
      NumberField,
      PasswordField
    },
    watch: {
      fields (value) {
        this.refresh()
      }
    },
    methods: {
      emit () {
        this.$emit('input', this.data)
      },
      refresh () {
        this.fields.forEach(field => {
          this.$set(this.data, field.name, this.value[field.name] === undefined ? '' : this.value[field.name])

          if (!this.watcherExist(`data.${field.name}`)) {
            this.$watch(`data.${field.name}`, () => this.emit())
          }
          if (!this.watcherExist(`value.${field.name}`)) {
            this.$watch(`value.${field.name}`, () => this.refresh())
          }
        })
      },
      watcherExist (expression) {
        if (this.watcherList.includes(expression)) {
          return true
        }

        this.watcherList.push(expression)

        return false
      }
    },
    created () {
      this.refresh()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/fields.vue